//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import OrganizationProjectCard from '../../forms/OrganizationProject/OrganizationProjectCard.vue'

export default {
  name: 'RelationshipCardWrapper',
  props: {
    relationshipObjectId: {
      type: Number,
      default: null
    },
    propertyKey: {
      type: String,
      default: null
    },
    objectId: {
      type: Number,
      default: null
    },
    objectType: {
      type: String,
      default: null
    },
    modeCustom: { // -> local
      type: Boolean,
      default: null
    },
    readonly: { // -> local
      type: Boolean,
      default: false
    },
    closable: { // -> local
      type: Boolean,
      default: true
    },
    cardParams: {
      type: Object,
      default: null
    },
    objectParams: {
      type: Object,
      default: null
    },
    objectData: {
      type: Object,
      default: null
    },
    typeKey: {
      type: String,
      default: null
    },
    subtypeKey: {
      type: String,
      default: null
    },
    headerHidden: { // -> local
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    create: {
      type: Boolean,
      default: false
    },
    createConfig: {
      type: Object,
      default: null
    }
  },
  data: function () {
    return {
      component: null,
      shown: false,
      isWrapperMounted: false,
      isCardMounted: false,
      objectTypeLocal: null,
      modeCustomLocal: false,
      loader: null
    }
  },
  computed: {
    isMounted: function () {
      return !!(this.shown && this.isWrapperMounted && this.isCardMounted)
    }
  },
  watch: {
    propertyKey: {
      handler: function (objectType, prevObjectType) {
        if (objectType) {
          this.objectTypeLocal = objectType
        } else if (prevObjectType) {
          this.objectTypeLocal = null
        }
      },
      immediate: true
    },
    '$route.path': {
      handler: function (path) {
        if (path && path.startsWith('/object/')) {
          this.$nextTick(() => {
            if (!this.objectType) {
              this.objectTypeLocal = this.$route.params.type
            }
          })
        }
      },
      immediate: true
    },
    objectTypeLocal: {
      handler: function (objectType) {
        if (objectType) {
          let loader = null
          this.component = null
          if (this.modeCustom == null || this.modeCustom === true) {
            if (objectType === 'organizationProject') {
              this.component = OrganizationProjectCard
              // loader = () => import('../../forms/Employee/EmployeeCard.vue')
            }
          }

          if (this.component || loader) {
            this.modeCustomLocal = true
            this.loader = loader
          } else {
            this.modeCustomLocal = false
            this.loader = () => import('./RelationshipCard.vue')
          }

          this.show()
        } else {
          this.hide()
        }
      },
      immediate: true
    }
  },
  mounted: function () {
    this.$nextTick(() => {
      this.isWrapperMounted = true
    })
  },
  methods: {
    onCreated: function (objectId) {
      this.$emit('created', objectId)
    },
    // following methods are REQUIRED ===
    show () {
      if (this.component) {
        this.shown = true
      } else {
        this.loader()
          .then(() => {
            this.component = () => this.loader()

            this.$nextTick(() => {
              this.shown = true
            })
          })
      }
    },
    hide () {
      this.shown = false
    },

    getCard () {
      return new Promise(resolve => {
        if (this.isMounted) {
          resolve(this.$refs.card)
        } else {
          const unwatch = this.$watch('isMounted', function (isMounted) {
            if (isMounted) {
              resolve(this.$refs.card)
              if (unwatch) {
                unwatch()
              }
            }
          }, {
            immediate: true
          })
        }
      })
    }
  }
}
